<div class="dialog-content-max">
  <form [formGroup]="userForm" *ngIf="!onlyView">
    <div *ngIf="!isEdit" class="grid">
      <div class="col-12">
 <span class="redallerttext ">Please ensure that given email address is correct otherwise newly
      created user will not get login credentials at his/her email address to login
    </span>
    </div>
   </div>

    <!-- <div *ngIf="orgType !== 'P'"  class="formgrid grid mt-2">
      <div class="field col-2 width80px">
              <label class="required-label ">User Type:</label>
      </div>
      <div class="field col-2">
                  <input formControlName="userType" type="radio" name="lic" value="normalLicensed" (change)="onLicenseChange('normalLicensed')"> Normal Licensed User
      </div>
        <div  class="field col-2">          
          <input formControlName="userType" type="radio" name="lic" value="businessUser" (change)="onLicenseChange('businessUser')"> Business User 
        </div>
      <span class="errormessage" *ngIf="userForm.get('userType').invalid && userForm.get('userType').touched">
        {{getErrorMessage(userForm, validation_message, 'userType')}}
      </span>
    </div> -->

    <!-- visible to practicing firm -->
    <div *ngIf="orgType == 'P'" class="field col-12 mt-2">
      <label class="required-label d-block text-center">User Type:</label>
      <div class="d-flex justify-content-center align-items-center" style="gap: 2rem;">
        <label>
          <input type="radio" id="firmUser" name="userType" value="N" formControlName="userType"
          (change)="onLicenseChange('firmUser')">
          Firm's User
        </label>

        <label>
          <input type="radio" id="clientUser" name="userType" value="Y" formControlName="userType"
          (change)="onLicenseChange('clientUser')">
          Client User
        </label>
      </div>

      <span class="errormessage" *ngIf="userForm.get('userType').invalid && userForm.get('userType').touched">
        {{getErrorMessage(userForm, validation_message, 'userType')}}
      </span>
    </div>



    <div  class="formgrid grid">
         <div *ngIf="authType == 'AD'" class="field col-4">
        <label for="loginid" class="required-label">Login ID<span class="maxchars">(Max 100 chars)</span> <span>*</span></label>
        <input type="text" class="form-control" id="loginid" inputId="loginid" name="loginid"
          formControlName="loginid" placeholder="Enter Login Id">
        <span class="errormessage" *ngIf="userForm.get('loginid').invalid && (userForm.get('loginid').touched ||userForm.get('loginid').dirty ) ">
          {{getErrorMessage(userForm ,validation_message,'loginid')}}
        </span>
      </div>
      <div   [ngClass]="authType == 'AD' ? 'field col-4 md:col-4 lg:col-4' : 'field col-6 md:col-6 lg:col-6'">
        <label for="firstname" class="required-label" >First Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
        <input type="text" class="form-control" id="firstname" inputId="firstname" name="firstname"
          formControlName="firstname" placeholder="Enter First Name">
        <span class="errormessage" *ngIf="userForm.get('firstname').invalid && (userForm.get('firstname').touched || userForm.get('firstname').dirty) ">
          {{getErrorMessage(userForm ,validation_message,'firstname')}}
        </span>
      </div>
    
      <div [ngClass]="authType == 'AD' ? 'field col-4 md:col-4 lg:col-4' : 'field col-6 md:col-6 lg:col-6'">
        <label for="lastname">Last Name<span class="maxchars"> (Max 100 chars)</span> </label>
        <input type="text" class="form-control" id="lastname" inputId="lastname" name="lastname"
          formControlName="lastname" placeholder="Enter Last Name">
        <span class="errormessage" *ngIf="userForm.get('lastname').invalid && (userForm.get('lastname').touched  || userForm.get('lastname').dirty )">
          {{getErrorMessage(userForm ,validation_message,'lastname')}}
        </span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-6">
        <label for="emailadd" class="required-label">Email Address<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
        <input type="text" class="form-control" id="emailadd" inputId="emailadd" name="emailadd"
          formControlName="emailadd" placeholder="Enter Email Address">
        <span class="errormessage" *ngIf="userForm.get('emailadd').invalid && (userForm.get('emailadd').touched || userForm.get('emailadd').dirty) ">
          {{getErrorMessage(userForm ,validation_message,'emailadd')}}
        </span>
      </div>
      <div *ngIf=" userForm.get('userType').value=='N'" class="field col-6" >
        <label for="managerid">Manager </label>
        <p-dropdown [options]="managerList" [filter]="true" appendTo="body" id="managerid" optionLabel="fullname"
          optionValue="userid" formControlName="managerid" inputId="managerid" name="managerid"
          placeholder="Select Manager" (onChange)="onManagerChange($event.value)" [resetFilterOnHide]="true" [showClear]="true"></p-dropdown>
      </div>

    </div>

    <div class="formgrid grid">
 <div class="field col-12 lg:col-6 md:col-6 sm:col-12" *ngIf="orgType == 'P'">
        <label for="groupid" class="required-label"> Client Group <span>*</span></label>
        <p-multiSelect [options]="clientGroupList" id="groupid" formControlName="groupid" optionLabel="groupname"optionaValue="groupid"
          inputId="groupid" appendTo="body" name="groupid" (onChange)="onClientGroupChange($event.value)"
          placeholder="Select Group" [pTooltip]="getclientgroupTooltip(userForm.get('groupid').value)"tooltipPosition="bottom"></p-multiSelect>
        <span class="errormessage" *ngIf="userForm.get('groupid').invalid && userForm.get('groupid').touched ">
          {{getErrorMessage(userForm,validation_message,'groupid')}}
        </span>
      </div>
              <!-- [ngClass]="loginuserdetails.requirevertlabel=='Y'? 'field col-12 lg:col-6 md:col-6 sm:col-12' : 'field col-12 lg:col-12 md:col-12 sm:col-12' " -->

      <div
        class="field col-12 lg:col-6 md:col-6 sm:col-12">
        <label for="companyid"class="required-label">Entity<span>*</span></label>
        <p-multiSelect [options]="entityList" id="companyid" formControlName="companyid" optionLabel="companyname"
          appendTo="body" inputId="companyid" placeholder="Select Entity"[resetFilterOnHide]="true" [showClear]="true"
           [pTooltip]=" getcompanyTooltip(userForm.get('companyid').value)"tooltipPosition="bottom"></p-multiSelect>
        <span class="errormessage" *ngIf="userForm.get('companyid').invalid && userForm.get('companyid').touched ">
          {{getErrorMessage(userForm,validation_message,'companyid')}}</span>

      </div>

     

      <div class="field col-12 lg:col-6 md:col-6 sm:col-12" *ngIf="configparams?.requirevertlabel==='Y'">
        <label for="verticalid" class="required-label"> {{configparams?.vertlabelname}}<span>*</span></label>
        <p-multiSelect [options]="verticalList" id="verticalid" formControlName="verticalid" optionLabel="name"
          inputId="verticalid" appendTo="body" name="verticalid"
          placeholder="Select {{configparams?.vertlabelname}} "[resetFilterOnHide]="true" [showClear]="true"
          [pTooltip]="getverticcalTooltip(userForm.get('verticalid').value)" tooltipPosition="bottom"></p-multiSelect>
        <span class="errormessage" *ngIf="userForm.get('verticalid').invalid && userForm.get('verticalid').touched ">
          {{getErrorMessage(userForm,validation_message,'verticalid')}}
        </span>
      </div>

    </div>

    <div class="formgrid grid">
      <div class="field col-6">
        <label for="departmentid" class="required-label">Department<span>*</span></label>
        <p-multiSelect [options]="departmentList" id="departmentid" inputId="departmentid"
          formControlName="departmentid" optionLabel="departmentname" appendTo="body" name="departmentid"
          [resetFilterOnHide]="true" [showClear]="true"
          placeholder="Select Department"[pTooltip]="getdepTooltip(userForm.get('departmentid').value)" tooltipPosition="left"></p-multiSelect>
        <span style="color:red" *ngIf="userForm.get('departmentid').invalid && userForm.get('departmentid').touched ">
          {{getErrorMessage(userForm,validation_message,'departmentid')}}
        </span>
      </div>
      <div class="field col-6">
        <label for="locationid" class="required-label">Location<span>*</span></label>
        <p-multiSelect [options]="locationList" id="locationid" inputId="locationid" formControlName="locationid"
          optionLabel="locationname" option appendTo="body" placeholder="Select Location"[resetFilterOnHide]="true" [showClear]="true"
          [pTooltip]="getlocTooltip(userForm.get('locationid').value)" tooltipPosition="bottom"></p-multiSelect>
        <span style="color:red" *ngIf="userForm.get('locationid').invalid && userForm.get('locationid').touched ">
          {{getErrorMessage(userForm,validation_message,'locationid')}}
        </span>
      </div>
    </div>
    <div class="formgrid grid" *ngIf="this.loginuserdetails?.orgid===1">
      <div class="field col-6">
       <label for="verticalid1" class="required-label">User Vertical<span>*</span></label>
        <p-dropdown [options]="verticalList1" id="verticalid1" formControlName="verticalid1" 
        optionLabel="name" optionValue="verticalid"
           appendTo="body" name="verticalid1"
          placeholder="Select User Vertical "[resetFilterOnHide]="true" [showClear]="true"
          [pTooltip]="getvertical1Tooltip(userForm.get('verticalid1').value)" tooltipPosition="bottom"></p-dropdown>
        <span style="color:red" *ngIf="userForm.get('verticalid1').invalid && userForm.get('verticalid1').touched ">
          {{getErrorMessage(userForm,validation_message,'verticalid1')}}
        </span>
      </div>

      </div>


    <div class="formgrid grid">
      <div class="field col-6" *ngIf="isEdit">
        <label for="activeflag">Active Flag</label>
        <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body" name="activeflag"
          optionLabel="labelname" optionValue="value" formControlName="activeflag"></p-dropdown>

      </div>
      <div class="field col-6" *ngIf="isEdit">
        <label for="lockstatus">Lock Status <i class="fa fa-lock" style="color: blue;" ></i></label>
        <p-dropdown [options]="lockStatus" inputId="lockstatus" [filter]="true" appendTo="body" name="lockstatus"
          optionLabel="labelname" optionValue="value" formControlName="lockstatus"></p-dropdown>

      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-6">
        <label for="emailalerts">Email Alerts </label>
        <p-dropdown appendTo="body" [options]="sendmaillist" optionLabel="labelname" optionValue="value"
          formControlName="emailalerts" inputId="emailalerts" name="emailalerts" id="value"></p-dropdown>

      </div>

      <!-- <div class="field col-6">
        <label for="mobilenumber">Mobile Number </label>
        <input type="text" appendTo="body" class="form-control" formControlName="mobilenumber" inputId="mobilenumber"
          name="mobilenumber" placeholder="Enter Mobile Number (Max length 20 characters)">

      </div> -->
      <div class="field col-6">
            <label  for="mobilenumber" >Mobile Number<span class="maxchars"> (Max 15 digits)</span></label>
<div class="modern-phone-wrapper">
  <div class="country-select">
    <select formControlName="countryCode">
      <option *ngFor="let code of countryCodes" [value]="code.value">
        {{ code.label }}
      </option>
    </select>
  </div>
  <input  id="mobilenumber" inputId="mobilenumber"
  class="form-control"  type="text" formControlName="mobilenumber" 
    placeholder="Enter Phone number"/>
</div>
 <span class="errormessage" *ngIf="userForm.get('mobilenumber').invalid && (userForm.get('mobilenumber').touched || userForm.get('mobilenumber').dirty )">
              {{getErrorMessage(userForm ,validation_message,'mobilenumber')}}
            </span>

            <!-- <label  for="mobile" >Mobile Number <span class="maxchars">(Max 20 chars)</span></label>
            <input type="text" class="form-control" id="mobile" inputId="mobile"  name="mobile" formControlName="mobile" placeholder="Enter Mobile Number" (keypress)="utilityservice.onlyNumberKey($event)" >
            <span class="errormessage" *ngIf="auditorForm.get('mobile').invalid && auditorForm.get('mobile').touched || auditorForm.get('mobile').dirty ">
              {{getErrorMessage(auditorForm ,validation_message,'mobile')}}
            </span>  -->
        </div>
    </div>
    <div class="formgrid grid">
      <!-- <div class="field col-6">
                    <label for="emailcc">Email CC To Admin <span >&nbsp;*</span></label>
                  <input type="email" class="form-control"   appendTo="body"  placeholder="Enter email for CC" 
                  formControlName="emailcc"   inputId="emailcc" name="emailcc" >
                 <span style="color:red" *ngIf="userForm.get('emailcc').invalid  && userForm.get('emailcc').touched">
                    {{getErrorMessage(userForm,validation_message,'emailcc')}}
                    </span>
                </div> -->
      <div  *ngIf="orgType !== 'P'"class="field col-6">
        <label for="emailcc">Email CC To Admin </label>
        <p-dropdown appendTo="body" [options]="sendmaillist" optionLabel="labelname" optionValue="value"
          formControlName="emailcc" inputId="emailcc" name="emailcc"></p-dropdown>
        <span style="color:red" *ngIf="userForm.get('emailcc').invalid  && userForm.get('emailcc').touched">
          {{getErrorMessage(userForm,validation_message,'emailcc')}}
        </span>
      </div>
      <div class="field col-6" *ngIf="!isEdit">
        <label for="userrole" class="required-label">User Role<span>*</span></label>
        <p-dropdown [options]="userrolelist" optionLabel="labelname" optionValue="value" appendTo="body"
          formControlName="userrole" id="value" inputId="userrole" name="userrole" placeholder="Select User Role"></p-dropdown>
        <span style="color:red" *ngIf="userForm.get('userrole').invalid  && userForm.get('userrole').touched">
          {{getErrorMessage(userForm,validation_message,'userrole')}}
        </span>
      </div>

    </div>
    <div class="formgrid grid">

      <div class="field col-6" *ngIf="!isEdit">
        <label for="productid" class="required-label">Product <span>*</span></label>
        <p-multiSelect [options]="productList" id="productid" formControlName="productid" optionLabel="productinitial"
        inputId="productid"  appendTo="body" placeholder="Select Product"[resetFilterOnHide]="true" [showClear]="true"
           [pTooltip]="getProductTooltip(userForm.get('productid').value)" tooltipPosition="bottom"></p-multiSelect>
        <span style="color:red" *ngIf="userForm.get('productid').invalid && userForm.get('productid').touched ">
          {{getErrorMessage(userForm,validation_message,'productid')}}
        </span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-6" *ngIf="isEdit">
        <label for="dailyflag">Daily Escalation Flag</label>
        <p-dropdown [options]="dailyFlag" inputId="dailyflag" appendTo="body" name="dailyflag"
          optionLabel="labelname" optionValue="value" formControlName="dailyflag"></p-dropdown>
      </div>
   
    </div>
    <div class="grid"  *ngIf="isEdit && this.loginuserdetails.orgid===0 ">
        <div class="field col-3" >
        <label for="loggedflag">Logged Flag</label>
        <p-dropdown [options]="dailyFlag" inputId="loggedflag"  appendTo="body" name="loggedflag"
          optionLabel="labelname" optionValue="value" formControlName="loggedflag"></p-dropdown>
      </div>
        <div class="field col-3" >
        <label for="isorgadmin">Is Org. Admin</label>
        <p-dropdown [options]="dailyFlag" inputId="isorgadmin"  appendTo="body" name="isorgadmin"
          optionLabel="labelname" optionValue="value" formControlName="isorgadmin"></p-dropdown>
      </div>
        <div class="field col-3" >
        <label for="repodownloadright">Repo. Download Right</label>
        <p-dropdown [options]="dailyFlag" inputId="repodownloadright" appendTo="body" name="repodownloadright"
          optionLabel="labelname" optionValue="value" formControlName="repodownloadright"></p-dropdown>
      </div>

       <div class="field col-3" >
        <label for="supportloginright">Support Login Right</label>
        <p-dropdown [options]="dailyFlag" inputId="supportloginright" appendTo="body" name="supportloginright"
          optionLabel="labelname" optionValue="value" formControlName="supportloginright"></p-dropdown>
      </div>
       
    </div>
    <div class="grid" *ngIf="isEdit  ">
   <div class="field col-4" >
        <label for="threemonthlock">Three Month Lock <i class="fa fa-lock errormessage" ></i> </label>
        <p-dropdown [options]="threemonthLocklist" inputId="threemonthlock" appendTo="body" name="threemonthlock"
          optionLabel="labelname" optionValue="value" formControlName="threemonthlock"></p-dropdown>
      </div>
        <div class="field col-4 padding24" *ngIf="this.loginuserdetails.orgid===0">
       <p-button (click)="isresetmodal=true"  styleClass="customeaprv" label="Reset Password"></p-button>
      </div>
    </div>
  </form>
  <div *ngIf="isEdit">
    <p-accordion [activeIndex]="0">
      <p-accordionTab header="User Product Mapping">
        <form [formGroup]="mappedmoduleForm">
          <div class="grid">
            <div class="col-12 md:col-2 lg:col-2 sm:col-12">
              <button pButton (click)="addnewrow()" class=" customeadd">Add Row</button> &nbsp;

            </div>
              <div class="col-10 md:col-10 lg:col-10 sm:col-12">
              <p class="filenotetext">You can choose a maximum of six products to be displayed on the top menu. The rest will appear on the drop down menu.</p>
            </div>
          </div>
          
          <div class="grid">
            <div class="table-responsive col-12 md:col-12 lg:col-12 sm:col-12">
              <table class="table table-bordered">
                <thead>
                  <tr class="thead-row">
                    <th>Product</th>
                    <th>Role</th>
                    <th>Create Right</th>
                    <th>Download Right</th>
                    <th>Display on Top Menu</th>
                    <th *ngIf="formArr.controls.length > 1">Delete Row</th>
                  </tr>
                </thead>
                <tbody formArrayName="Rows">
                  <tr *ngFor="let itemrow of formArr.controls; let i=index;let l=last" [formGroupName]="i">
                    <td><p-dropdown appendTo="body" [options]="productList" optionLabel="productname"
                        optionValue="productid" (onChange)="onSelectProduct($event.value,i)"
                        [filter]="true" [resetFilterOnHide]="true" 
                         formControlName="productid"
                         name="productid-{{i}}"id="productid-{{i}}"></p-dropdown>
                       <span class="errormessage"
                                    *ngIf="itemrow.get('productid').invalid && itemrow.get('productid').touched ">
                                    {{getErrorMessage(itemrow ,validation_message,'productid')}}
                                </span>
                      </td>
                    <td>
                      <p-dropdown appendTo="body" [options]="rolelistdynamic[i]" optionLabel="rolename"
                        optionValue="roleid" placeholder="Select" formControlName="role" 
                        name="role-{{i}}"id="role-{{i}}" ></p-dropdown>
                             <span class="errormessage"
                                    *ngIf="itemrow.get('role').invalid && itemrow.get('role').touched ">
                                    {{getErrorMessage(itemrow ,validation_message,'role')}}
                                </span>
                    </td>

                    <td class="textaligncenter"><input type="checkbox" name="create" formControlName="create"
                        [checked]="selectedValue === 'Y'"></td>
                    <td class="textaligncenter"><input type="checkbox" name="download" formControlName="download"
                        [checked]="selectedValue === 'Y'"></td>
                    <td class="textaligncenter"><input type="checkbox" name="topmenu" formControlName="topmenu"
                        [checked]="selectedValue === 'Y'"></td>
                    <td class="textaligncenter" style="text-align: center !important;" *ngIf="formArr.controls.length > 1 " class="deletetd"  pTooltip="Delete" tooltipPosition="left" ><i class="fas fa-trash-alt red-icon"  aria-hidden="true" (click)="deleteRownew(i)"></i></td>


                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </form>

      </p-accordionTab></p-accordion>

  </div>
  <div *ngIf="onlyView">
    <form [formGroup]="mappedmoduleForm">

      <table class="table">
        <thead>
          <tr class="thead-row">
            <th>Product</th>
            <th>Role</th>
            <th>Create Right</th>
            <th>Download Right</th>
            <th>Display on Top Menu</th>
          </tr>
        </thead>
        <tbody formArrayName="Rows">
          <tr *ngFor="let itemrow of formArr.controls; let i=index;let l=last" [formGroupName]="i">
            <td><input type="text" class="form-control" formControlName="productid" id="productid" name="productname"
                [readonly]="onlyView"></td>
            <td> <input type="text" class="form-control" formControlName="role" id="roleid" name="role"
                [readonly]="onlyView"></td>

            <td class="textaligncenter"><input type="checkbox" name="create" formControlName="create"
                [checked]="selectedValue === 'Y'" [readonly]="onlyView"></td>
            <td class="textaligncenter"><input type="checkbox" name="download" formControlName="download"
                [checked]="selectedValue === 'Y'" [readonly]="onlyView"></td>
            <td class="textaligncenter"><input type="checkbox" name="topmenu" formControlName="topmenu"
                [checked]="selectedValue === 'Y'" [readonly]="onlyView"></td>


          </tr>
        </tbody>
      </table>
    </form>
  </div>



  <div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose" (click)="closemodal(userForm,this.ref,'Are you sure, you want to close?')"></p-button>

    <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
      (click)="addUser()"></p-button>
  </div>

</div>

<p-dialog header="Reset Password" [(visible)]="isresetmodal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false"   [style]="{width: '600px'}" [contentStyle]="{height:'200px'}" position="center">
 <div class="dialog-content-max">

  <div class="grid">
    <div class="col-12">
      <input type="radio"
             name="password"
             [(ngModel)]="manualpasswordreset"
             value="autoresetpaswrd">
      Automatic Password Reset
    </div>
  </div>

  <div class="grid">
    <div class="col-12">
      <input type="radio"
             name="password"
             [(ngModel)]="manualpasswordreset"
             value="manualpasswordreset">
      Manually Reset Password
    </div>
  </div>

  <div class="grid" *ngIf="manualpasswordreset === 'manualpasswordreset'">
    <div class="col-6">
      <label class="required-label">Enter New Password</label>

      <input [(ngModel)]="Newpassword"
             type="text"
             class="form-control"
             placeholder="Enter New Password"       (input)="clearPasswordError()">

      <span class="errormessage" *ngIf="passwordmessage !== ''">
        {{passwordmessage}}
      </span>
    </div>
  </div>

</div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="isresetmodal=false"></p-button>
    <p-button class="m-1 w-full" label="Reset" styleClass="customesave" (click)="resetpassword()"></p-button>
  </div>
</p-dialog>
<p-dialog header="View Password" [(visible)]="viewpassword" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false"   [style]="{width: '600px'}" [contentStyle]="{height:'200px'}" position="center">
 <div class="dialog-content-max">

  <div class="grid">
    <div class="col-12">
 Your new password is : {{generatedpswd}}

    </div>
  </div>
</div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="viewpassword=false"></p-button>
  </div>
</p-dialog>
